import type { GetPhoneUrl } from './types';

export const getPhoneUrl: GetPhoneUrl = phoneNumber => (
  new URL(`tel:${phoneNumber}`)
);
